import React from "react";
import styled from "styled-components";
import withLanguageContext from "lib/hocs/withLanguageContext";

const StyledTitle = styled.span`
  width: 100%;
  text-align: left;
`;

const handleHelpClick = (url, event) => {
  event.preventDefault();
  luvit.OpenHelpWin(url);
};

const MenuNode = function ({
  itemId,
  type,
  className,
  url,
  icon,
  target,
  title,
  label,
  expanded,
  highlight,
  goToPage,
  onExpand,
  children,
  languageContext,
  menunameId,
}) {
  const toggleSubmenyGroup = onExpand,
    childNodes = React.Children.toArray(children);

  const linkTypes = {
    link: "a",
    button: "button",
    div: "div",
  };

  const TagType = highlight
    ? linkTypes.link
    : url
    ? linkTypes.link
    : linkTypes.button;

  const labelMenuToggleButton = `${
    expanded ? languageContext("hide") : languageContext("show")
  } ${languageContext("content")} `;

  const isHelpLink = menunameId === "mni_help";

  const handleGoToPageClick = (e) => {
    if (isHelpLink) {
      handleHelpClick(url, e);
    } else {
      goToPage(e);
    }
  };

  return (
    <>
      <li
        id={itemId}
        className={`${type} ${highlight ? "active" : ""}`}
        role="menuitem"
        title={label}
      >
        {TagType === "a" && (
          <a
            {...(TagType === "a" && {
              href: childNodes.length < 1 ? url : "#",
            })}
            {...(TagType === "a" && { target: target })}
            aria-label={label}
            className={type === "menu-expandlist-item" ? "menu-subitem" : ""}
            onClick={handleGoToPageClick}
            {...(highlight && { "aria-current": "page" })}
          >
            {!!icon && (
              <span
                className={(icon || "") + " menu-icon"}
                aria-label={title}
                aria-hidden="true"
                onClick={handleGoToPageClick}
              />
            )}

            <StyledTitle>{title}</StyledTitle>
          </a>
        )}

        {TagType === "button" && (
          <button
            aria-label={label}
            aria-controls={`menu-item-${itemId}`}
            aria-expanded={expanded ? "true" : "false"}
            className={highlight ? "menu-row" : ""}
            onClick={(event) => onExpand(event)}
          >
            {!!icon && (
              <span
                className={(icon || "") + " menu-icon"}
                aria-label={title}
                aria-hidden="true"
                onClick={goToPage}
              >
                &nbsp;&nbsp;
              </span>
            )}

            <StyledTitle>{title}</StyledTitle>
          </button>
        )}

        {childNodes.length > 0 && (
          <span
            aria-controls={`menu-item-${itemId}`}
            aria-hidden="true"
            onClick={toggleSubmenyGroup}
            aria-label={labelMenuToggleButton}
            className={expanded ? "icon-collapse" : "icon-expand"}
          >
            <span className="sr-only">{labelMenuToggleButton}</span>
          </span>
        )}
      </li>

      {childNodes.length > 0 && expanded && (
        <ul id={`menu-item-${itemId}`} role="group">
          {children}
        </ul>
      )}
    </>
  );
};

export default withLanguageContext(MenuNode, "Menu");
